import { Route, Routes } from 'react-router-dom'

import {
  RedirectIfAuthenticated,
  RequireAuth,
  RequireModule,
  RequireRole,
  RequireService,
} from '@/auth/RouteGuards'
import { AppLayout } from '@/components/layout/AppLayout'
import { ChangePasswordPage } from '@/pages/ChangePasswordPage'
import { DashboardPage } from '@/pages/DashboardPage'
import { ForbiddenPage, NotFoundPage } from '@/pages/ErrorPages'
import { InstrumentsPage } from '@/pages/InstrumentsPage'
import { LoginPage } from '@/pages/LoginPage'
import { SettingsPage } from '@/pages/SettingsPage'
import { AttendancePage } from '@/pages/attendance/AttendancePage'
import { BillingPage } from '@/pages/billing/BillingPage'
import { FeedbackPage } from '@/pages/feedback/FeedbackPage'
import { LocationsPage } from '@/pages/locations/LocationsPage'
import { ModulesPage } from '@/pages/modules/ModulesPage'
import { RoomSchedulePage } from '@/pages/rooms/RoomSchedulePage'
import { RoomsPage } from '@/pages/rooms/RoomsPage'
import { SchedulePage } from '@/pages/schedule/SchedulePage'
import { StudentDetailPage } from '@/pages/students/StudentDetailPage'
import { StudentsPage } from '@/pages/students/StudentsPage'
import { TeacherDetailPage } from '@/pages/teachers/TeacherDetailPage'
import { TeachersPage } from '@/pages/teachers/TeachersPage'
import { UsersPage } from '@/pages/users/UsersPage'

export function App() {
  return (
    <Routes>
      {/* Trasy publiczne */}
      <Route
        path="/logowanie"
        element={
          <RedirectIfAuthenticated>
            <LoginPage />
          </RedirectIfAuthenticated>
        }
      />
      <Route path="/brak-dostepu" element={<ForbiddenPage />} />

      {/* Zmiana hasła jest poza layoutem — konto z wymuszoną zmianą nie ma
          jeszcze dostępu do reszty aplikacji. */}
      <Route
        path="/zmiana-hasla"
        element={
          <RequireAuth>
            <ChangePasswordPage />
          </RequireAuth>
        }
      />

      {/* Aplikacja właściwa */}
      <Route element={<RequireAuth />}>
        <Route element={<AppLayout />}>
          <Route index element={<DashboardPage />} />
          <Route path="ustawienia" element={<SettingsPage />} />

          {/* Sekcje objęte modułami — wyłączony moduł pokazuje wyjaśnienie
              zamiast treści, a backend i tak odmawia odpowiedzi. */}
          <Route element={<RequireModule slug="uczniowie" />}>
            <Route path="uczniowie" element={<StudentsPage />} />
            <Route path="uczniowie/:studentId" element={<StudentDetailPage />} />
          </Route>
          <Route element={<RequireModule slug="grafik" />}>
            <Route path="grafik" element={<SchedulePage />} />
          </Route>
          <Route element={<RequireModule slug="obecnosci" />}>
            <Route path="obecnosci" element={<AttendancePage />} />
          </Route>
          <Route element={<RequireModule slug="rozliczenia" />}>
            <Route path="rozliczenia" element={<BillingPage />} />
          </Route>

          <Route element={<RequireModule slug="nauczyciele" />}>
            {/* Profil nauczyciela zostaje dostępny dla wszystkich ról — nauczyciel
                otwiera własny z Ustawień. Backend pilnuje, by nie sięgnął po cudzy. */}
            <Route path="nauczyciele/:teacherId" element={<TeacherDetailPage />} />
            <Route element={<RequireRole roles={['OWNER', 'ADMIN']} />}>
              <Route path="nauczyciele" element={<TeachersPage />} />
            </Route>
          </Route>

          <Route element={<RequireModule slug="sale" />}>
            <Route path="sale" element={<RoomsPage />} />
            <Route path="sale/:roomId" element={<RoomSchedulePage />} />
          </Route>

          <Route element={<RequireRole roles={['OWNER']} />}>
            <Route path="oddzialy" element={<LocationsPage />} />
            <Route path="instrumenty" element={<InstrumentsPage />} />
          </Route>

          {/* Zakres wdrożenia prowadzi wykonawca — tak samo jak zgłoszenia. */}
          <Route element={<RequireService />}>
            <Route path="zgloszenia" element={<FeedbackPage />} />
            <Route path="moduly" element={<ModulesPage />} />
          </Route>

          <Route element={<RequireRole roles={['OWNER', 'ADMIN']} />}>
            <Route path="konta" element={<UsersPage />} />
          </Route>
        </Route>
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}
